(() => {
  const storageKey = 'iz_recently_viewed_products_v1';
  const cardCacheKey = 'iz_recently_viewed_cards_v1';
  const cardCacheLifetime = 15 * 60 * 1000;

  const readCardCache = () => {
    try {
      const cache = JSON.parse(sessionStorage.getItem(cardCacheKey) || '{}');
      return cache && typeof cache === 'object' ? cache : {};
    } catch (error) {
      return {};
    }
  };

  const writeCardCache = (cache) => {
    try {
      sessionStorage.setItem(cardCacheKey, JSON.stringify(cache));
    } catch (error) {
      // Loading still works when browser storage is unavailable or full.
    }
  };

  const createCard = (html, index) => {
    const documentFragment = new DOMParser().parseFromString(html, 'text/html');
    const card = documentFragment.querySelector('[data-recent-product-card]')?.firstElementChild || null;
    return card;
  };

  const refreshSlider = (section) => {
    window.requestAnimationFrame(() => {
      const slider = section.querySelector('scroll-slider-component');
      if (!slider || typeof slider.initScroller !== 'function') return;
      slider.initScroller();
    });
  };

  const showCard = (section, slots, card, index) => {
    const slot = slots[index];
    if (!slot || !card) return;
    slot.replaceChildren(card);
    slot.hidden = false;
    section.hidden = false;
    refreshSlider(section);
  };

  const loadSection = async (section) => {
    if (section.dataset.loaded === 'true') return;
    section.dataset.loaded = 'true';

    let handles = [];
    try {
      const stored = JSON.parse(localStorage.getItem(storageKey) || '[]');
      handles = Array.isArray(stored) ? stored : [];
    } catch (error) {
      return;
    }

    const excluded = new Set((section.dataset.excludedHandles || '').split('|').filter(Boolean));
    const limit = Number.parseInt(section.dataset.limit, 10) || 8;
    handles = [...new Set(handles)].filter((handle) => handle && !excluded.has(handle)).slice(0, limit);
    if (!handles.length) return;

    const rootUrl = section.dataset.rootUrl || '/';
    const slots = Array.from(section.querySelectorAll('[data-recently-viewed-slot]'));
    slots.slice(handles.length).forEach((slot) => slot.remove());
    const cardCache = readCardCache();

    handles.forEach(async (handle, index) => {
      const cached = cardCache[handle];
      if (cached && Date.now() - cached.savedAt < cardCacheLifetime) {
        const card = createCard(cached.html, index);
        if (card) {
          showCard(section, slots, card, index);
          return;
        }
      }

      const url = `${rootUrl}products/${encodeURIComponent(handle)}?section_id=recently-viewed-card`;
      try {
        const response = await fetch(url, { credentials: 'same-origin' });
        if (!response.ok) return;

        const html = await response.text();
        const card = createCard(html, index);
        if (!card) return;

        cardCache[handle] = { html, savedAt: Date.now() };
        writeCardCache(cardCache);
        showCard(section, slots, card, index);
      } catch (error) {
        slots[index]?.remove();
        refreshSlider(section);
        // A failed card must not delay the cards that loaded successfully.
      }
    });
  };

  const initialize = () => {
    document.querySelectorAll('[data-recently-viewed-products]').forEach((section) => loadSection(section));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }

  document.addEventListener('shopify:section:load', initialize);
})();
